__webpack_require__.p = "/worldcup/";